// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__X1Jp0","wrapper":"Footer_wrapper__fTaM1","links":"Footer_links__dArvA"};